export default "__VITE_ASSET__C1hwGR1o__"